import React from "react";
import "../../styles/update/about.css";
import {
  Code2,
  Smartphone,
  Cloud,
  Palette,
  Zap,
  Database,
  CheckCircle2,
} from "lucide-react";
const technologies = [
  { name: "React.js", icon: Code2, color: "from-blue-500 to-cyan-500" },
  { name: "Supabase", icon: Database, color: "from-green-500 to-emerald-500" },
  { name: "PWA", icon: Smartphone, color: "from-purple-500 to-pink-500" },
  { name: "Edge Functions", icon: Zap, color: "from-orange-500 to-red-500" },
  { name: "Netlify", icon: Cloud, color: "from-teal-500 to-cyan-500" },
  { name: "Responsive", icon: Palette, color: "from-violet-500 to-purple-500" },
];

const features = [
  "Progressive Web App (PWA) Support",
  "Native Android & iOS Installation",
  "Supabase and Firebase Integration",
  "Edge & Netlify Functions",
  "AWS And Other Cloud Services",
  "Laravel , Node.js, Fastapi and Express",
  "LLM and MCP Server Development",
  "IOT and YOLO11 advance Solutions",
];
export default function About({ setAboutRef }) {
  const aboutRef = React.useRef(null);

  React.useEffect(() => {
    // Pass the ref up to Main
    if (setAboutRef) setAboutRef(aboutRef);
  }, [setAboutRef]);
  return (
    <div>
      {/* Technologies Section */}
      {/* <div className="mb-16">
        <h2
          className="text-center text-[2rem] text-white mb-8"
          style={{ fontWeight: "700" }}
        >
          Tech Stack & Expertise
        </h2>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-6">
          {technologies.map((tech, index) => {
            const Icon = tech.icon;
            return (
              <div
                key={index}
                className="group relative p-6 rounded-2xl bg-slate-800/30 backdrop-blur-sm border border-slate-700/50 hover:border-slate-600 transition-all duration-300 hover:scale-105 hover:shadow-xl hover:shadow-blue-500/10"
              >
                <div
                  className={`w-14 h-14 mx-auto mb-4 rounded-xl bg-gradient-to-br ${tech.color} flex items-center justify-center shadow-lg transition-transform duration-300 group-hover:rotate-6`}
                >
                  <Icon className="w-7 h-7 text-white" />
                </div>
                <p
                  className="text-center text-slate-300 text-sm"
                  style={{ fontWeight: "600" }}
                >
                  {tech.name}
                </p>
              </div>
            );
          })}
        </div>
      </div> */}

      {/* Features Grid */}

      <div className="about" ref={aboutRef}>
        <div className="frame">
          <div className="img-frame" />
          <img
            className="about-img"
            src="/images/profile.png"
            // src={require("../../assets/images/man.jpeg")}
            alt="profile"
          />
          {/* <img src={require("../../assets/images/man.jpeg")} height={"100%"} style={{borderRadius:10}} alt="profile" /> */}
        </div>
        <div className="intro">
          <p className="section-heading">ABOUT ME</p>
          <div className="mt-4">
            <p className="text">
              Hello! I'm Muhammad Imran, a skilled Full-Stack Developer with
              over 5 years of experience in building innovative and
              user-friendly applications. My expertise spans various
              cutting-edge technologies, including Laravel PHP, React Native,
              Vue.js, and frontend frameworks like Bootstrap and Tailwind CSS. I
              specialize in creating robust web and mobile applications, from
              crafting intuitive user interfaces to implementing complex backend
              logic. My proficiency in AI and machine learning allows me to
              design and deploy custom models using TensorFlow and Python,
              enabling data-driven solutions tailored to client needs. I am
              passionate about delivering high-quality projects, and my
              portfolio reflects diverse experiences, from API integration and
              database management to deploying mobile apps and websites on app
              stores. Whether you're looking for a tech-savvy developer for a
              groundbreaking idea or a reliable team member to enhance your
              existing project, I am here to bring your vision to life. Let’s
              collaborate and create something extraordinary!
            </p>
          </div>
          <div className="action">
            <button className="hire-btn">Hire Me</button>
            <a
              href="https://docs.google.com/document/d/11xOuGMCFZo90K_UgZ2ZFBTVGa7AGaTm20zcYdkgYFfw/edit?usp=sharing"
              className="resume-btn"
              target="_blank"
              rel="noreferrer"
            >
              Resume
            </a>
            {/* <button className="resume-btn"></button> */}
          </div>
        </div>
      </div>
      <div style={{ marginTop: 20 }}>
        <h2
          className="text-center text-[2rem] dark:text-white mb-8"
          style={{ fontWeight: "700" }}
        >
          Key Features & Capabilities
        </h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group p-5 rounded-xl dark:bg-slate-800/30 backdrop-blur-sm border border-slate-700/50 hover:border-blue-500/50 hover:bg-slate-800/50 transition-all duration-300 hover:scale-105"
            >
              <div className="flex items-start gap-3">
                <CheckCircle2 className="w-5 h-5 text-blue-400 flex-shrink-0 mt-0.5 group-hover:text-blue-300 transition-colors" />
                <p className="dark:text-slate-300 text-sm leading-relaxed  group-hover:text-white transition-colors">
                  {feature}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
